export default "__VITE_ASSET__5e25887a__"